import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const PauseBuy = () => {
    const navigate = useNavigate();
	const userData = useSelector((state) => state.user.user);

	//Redirect user if they're not Admin
	if (!userData.isAdmin) {
		navigate("/");
	}
    const [phaseData, setPhaseData] = useState({
		phase: "phase1",
		title: "",
		link: "",
	});
    // set PhaseData data
    let setInputData = (e) => {
		setPhaseData({
			...phaseData,
			[e.target.name]: e.target.value,
		});
        
	};
    // <------------ Handle Phase update on Submit ------------>

    const updatePhase = async() => { // On Submit
        try {
            
            await axios.post('/pausebuy', {phaseData});
            navigate("/admin");
			toast.success("Button updated!");
        } catch (error) {
            console.log(error);
        }
		
	};
    return (
		<>
			<div className="py-[5%] px-[5%] bg-blue2 dark:bg-dark">
				<h1 className="text-blue dark:bg-dark  bg-blue2 text-center font-bold text-4xl pt-[30px] md:text-4xl dark:text-white ">
					Edit Enrollment
				</h1>

                <div className="mt-16   flex gap-5 items-center justify-center">
						<label
							className="font-medium text-xl text-dark dark:text-white mr-2 "
							htmlFor="phase"
						>
							Choose a Phase:
						</label>

						<select
							className="font-medium text-md p-2"
							onChange={setInputData}
							name="phase"
						>
							<option value="phase1">Phase1</option>
							<option value="phase2">Phase2</option>
							<option value="phase3">Phase3</option>
						</select>
					</div>

				<div className="mx-[10%] mt-[50px] flex flex-col items-center gap-5 justify-center">
					<div className="flex  justify-left items-center gap-5 ">
						<p className="text-darkBlue dark:bg-dark  bg-blue2 text-center font-medium text-md md:text-xl dark:text-white">
							Button Title:
						</p>
						<input
							name="title"
							onChange={setInputData}
							value={phaseData && phaseData.title}
							className=" w-[500px] text-md font-medium p-3 rounded-md"
						></input>
					</div>
					<div className="flex justify-left items-center gap-5 ">
						<p className="text-darkBlue dark:bg-dark  bg-blue2 text-center font-medium text-md md:text-xl dark:text-white">
							Button Link:
						</p>
						<input
							name="link"
							onChange={setInputData}
							value={phaseData && phaseData.link}
							className=" w-[500px] text-md font-medium p-3 rounded-md"
						></input>
					</div>

					

					<button
						onClick={updatePhase}
						className="font-semibold flex items-center justify-center border-2 border-blue6 rounded-sm py-2.5 px-10 mt-10 mx-auto bg-blue6 text-white hover:text-white hover:border-black hover:bg-black ease-in-out duration-300 dark:bg-blue dark:border-blue dark:hover:bg-dark dark:hover:text-blue"
					>
						Update Enrollment
					</button>
				</div>
			</div>
		</>
	);
}

export default PauseBuy